import $ from 'jquery';

/**
 * @desc Implements Accordion
 */
export default class MCAccordion {
  /**
   * @param {object} options
   * @param {string} options.listSelector
   * @param {string} options.accordionSelector
   * @param {string} options.btnSelector
   * @param {string} options.activeClass
   */
  constructor({
    listSelector,
    accordionSelector,
    btnSelector,
    activeClass = 'active',
  } = {}) {
    this.$list = $(listSelector);
    this.$accordionBtn = this.$list.find(btnSelector);
    this.accordionSelector = accordionSelector;
    this.activeClass = activeClass;
    this.accordionGroups = {};
    this.header = $('.js-main-header');

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.$list.length) {
      this.isInitialized = false;

      return;
    }

    this.$list.map((index, $elem) => {
      this.accordionGroups[$($elem).data('id')] = $($elem).find(this.accordionSelector);
      return true;
    });

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.$accordionBtn.on('click', (elem) => {
      const $this = $(elem.target);
      const id = $this.parent().data('id');
      const isOpen = $this.parent().hasClass(this.activeClass);
      const list = this.accordionGroups[id];

      list.removeClass(this.activeClass);
      list.find(this.$accordionBtn).attr('aria-expanded', 'false');

      if (!isOpen) {
        $this.parent().addClass(this.activeClass);
        $this.attr('aria-expanded', 'true');
      }

      /* timeout is needed because we have css animation on hide open accordion with 150ms time */
      window.setTimeout(() => {
        this.scrollIntoViewIfNeeded($this[0]);
      }, 200);
    });
  }

  scrollIntoViewIfNeeded(target) {
    if (target.getBoundingClientRect().top < 0) {
        $('html, body').animate({ scrollTop: $(target).offset().top - this.header.height() }, 250);
    }
  }
}
